import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 100 * 1000 } } });

// If/when the clinician reschedules an appointment, we need to invalidate the useTodaysAppointments query
// (as keyed by "getUserAppointment") so that the upcoming "waiting" rooms re-trigger.
// See useTestPatientRoom.waitForSchedulingChange
queryClient.getQueryCache().subscribe((event) => {
  if (event.type === 'updated' && event.action.type === 'success') {
    const key = event.query.queryKey;

    if (key.includes('clinicianAppointment')) {
      console.log('refetched clinicianAppointment');

      // this will cause "waiting" rooms to immediately retry to get a room token
      // (see useTestPatientRoom.waitForSchedulingChange)
      queryClient
        .invalidateQueries({
          queryKey: ['getUserAppointment']
        })
        .then(() => console.log('refetched useTodaysAppointments'));
    }
  }
});
